import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AppliancesMostCostlyStyles";
import ApplianceCostDisc from "../components/ApplianceCostDisc";

export default class AppliancesMostCostly extends Component {
  render() {
    const { most_costly_appliances, currency_unit, energy_unit } = this.props;
    return (
      <Fragment>
        <h3 className={css(styles.mostCostlyTitle)}>
          Most Costly this {this.props.period.time_unit}
        </h3>
        {!most_costly_appliances.length ? (
          <h3 className={css(styles.notUsed)}>
            No appliances used during this period
          </h3>
        ) : null}
        <div className={css(styles.mostCostlyWrapper)}>
          {most_costly_appliances &&
            Object.keys(most_costly_appliances).map((appliance, i) => {
              return (
                <ApplianceCostDisc
                  path={"my-home"}
                  title={most_costly_appliances[appliance].name}
                  key={i}
                  order={i + 1}
                  cost={`${currency_unit}${most_costly_appliances[
                    appliance
                  ].cost.toFixed(2)}`}
                  rate={`${most_costly_appliances[appliance].consumed.toFixed(
                    2
                  )} ${energy_unit}`}
                  size={"small"}
                  id={most_costly_appliances[appliance].appliance_type_id}
                  icon={most_costly_appliances[appliance].icon}
                />
              );
            })}
        </div>
      </Fragment>
    );
  }
}
